var map = {
	"./1-th.wav": "RxCi",
	"./2-th.wav": "ue4k",
	"./3-th.wav": "YA0w",
	"./4-th.wav": "cYMe",
	"./5-th.wav": "mhHY",
	"./6-th.wav": "8Ren",
	"./7-th.wav": "wls5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t8Pg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio ^\.\/.*\-th\.wav$
// module id = t8Pg
// module chunks = 1